import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import 'react-credit-cards/lib/styles.scss';
import PaymentForm from './Form';
import Installments from './Installments';
import Checkbox from '../../components/Checkbox';
import { doPayment } from '../../services/PaymentApiService';
import { useStateContext } from '../../context/StateContext';
import { CUSTOM_PAYMENT_PROVIDER } from '../../utils/constants';
import { updateCheckoutFormContentState } from '../../reducers/actions';
import style from './payment.module.scss';

const Payment = ({ showInstallments = true }) => {
	const {
		state: {
			pageSettings: { providerId, conversationId, useFastPay } = {},
			is3DPayment,
			overview: { overviewDetail, totalPaymentPrice, totalPrice } = {},
			checkoutFormContent
		},
		dispatch
	} = useStateContext();
	const isCustomProvider = useMemo(() => providerId === CUSTOM_PAYMENT_PROVIDER, [providerId]);

	useEffect(() => {
		if (useFastPay && totalPaymentPrice > 0) {
			clearIyzicoForm();
			getCheckoutFormContent();
		}
	}, [totalPaymentPrice]);

	useEffect(() => {
		if (isCustomProvider && !checkoutFormContent) {
			getCheckoutFormContent();
		}

		return () => {
			clearIyzicoForm();
		};
	}, []);

	const clearIyzicoForm = () => {
		window.iyziInit = undefined;
		window.iyziUcsInit = undefined;
		updateCheckoutFormContentState({ payload: null, dispatch });
	};

	const getCheckoutFormContent = () => {
		const data = {
			conversationId,
			price: totalPaymentPrice,
			// paidPrice: totalPaymentPrice,
			paymentRequestDetail: overviewDetail?.filter(f => f?.isChecked).map(item => {
				return {
					id: item.id,
					price: item.paymentPrice
				};
			})
		};

		doPayment(data).then(res => {
			const scripts = res?.checkoutFormContent?.replace(/script type="text\/javascript"/g, '')?.replace(/\/script/g, '')?.replace(/<>/g, '');
			updateCheckoutFormContentState({ payload: scripts, dispatch });
		});
	};

	if (providerId === CUSTOM_PAYMENT_PROVIDER) {
		return (
			<>
				<Helmet>
					<script type='text/javascript'>
						{checkoutFormContent}
					</script>
				</Helmet>
				<div id="iyzipay-checkout-form"/>
			</>
		);
	}

	return (
		<>
			<div className={style.container}>
				<div className={style.title}>Kart bilgileri</div>

				<PaymentForm/>

				<div className={style.securePayment}>
					<Checkbox isChecked={is3DPayment} onChange={value => updateIs3DPaymentState({ payload: value, dispatch })} label='3D Secure ile ödeme yap'/>
				</div>
			</div>

			{showInstallments && <Installments/>}
		</>
	);
};

export default Payment;
